<template>

    <Transition name="slide-fade-top">
    <div class="modalHandler" v-if="showThis">

        <div class="lesschwab-modal" v-if="showThis">
          <div class="modal-headline">
            <h6>{{ title }}</h6>
            <div class="icon-close"></div>
          </div>
          <div class="modal-line"></div>
          <div v-html="definition"></div>
        </div>
    
    </div>
    </Transition>
  
</template>


<script>
export default {
  name: 'Popup',
  props: {
    showThis: Boolean,
    title: String,
    definition: String,
  }, 
}   
</script>

<style lang="scss" scoped>

  .modal-line {
    clear: both;
    max-width: 960px;
    height: 0;
    border-top: 0;
    border-right: 0;
    border-bottom: 1px solid rgba(189,194,199,.5);
    border-left: 0;
    margin-bottom: 20px;
  }

 .modal-headline {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
 }

  .modalHandler {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    h6 {padding-bottom: 0; margin-bottom: 0;}
  }

  .lesschwab-modal {
    display: flex; 
    flex-direction: column;
    width: 575px;
    height: 480px;
    padding: 20px;
    background-color: white;
    border: 1px solid #BDC2C7;
    border-top: 5px #FDC203 solid;
    box-shadow: 0px 0px 20px rgba(26, 34, 38, 0.2);
    cursor: pointer;
  }

</style>